import React, { useEffect } from 'react';
import './styles/CompanyOverview.css';
import PageOverView from '../components/Page Overview';
import Breadcrumb from '../components/BreadCrumb';
import { motion } from 'framer-motion';

const text = "About Us";

const paths = [
  { name: 'Home', link: '/' },
  { name: 'About Us', link: '' },
];

const CompanyOverview = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="page-overview">
        <PageOverView text={text} />
      </div>
      <div className="company-overview">
        <motion.div
          key="div0"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.7 }}
        >
          <section className="mission">
            <h2>Mission</h2>
            <h4>
              Creating Value Through Innovative Software Solutions
            </h4>
            <p>
              Our mission is to design, develop, and deliver high-quality software products that solve real-world problems, foster innovation, and create value for our clients and communities.
            </p>
          </section>
        </motion.div>
        <motion.div
          key="div1"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.7 }}
        >
          <section className="vision">
            <h2>Vision</h2>
            <h4>
              Empowering Global Businesses with Innovative Software Solutions
            </h4>
            <p>
              Empowering businesses worldwide with cutting-edge software solutions to achieve digital transformation and drive sustainable growth.
            </p>
          </section>
        </motion.div>
        <motion.div
          key="div2"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.7 }}
        >
          <section className="company-details">
            <h2>Company Overview</h2>
            <ul>
              <li><p className="detail-title">Company Name</p> <p className="detail-text">Beta Japan Software (BJS COMPANY LIMITED)</p></li>
              <li><p className="detail-title">Representative</p> <p className="detail-text">Mr. Dien Phan Truc</p></li>
              <li><p className="detail-title">Address</p> <p className="detail-text">89 Hoang Minh Giam St., Hoa Xuan Ward, Cam Le District, Da Nang City, Viet Nam</p></li>
              <li><p className="detail-title">Establishment</p> <p className="detail-text">August 2023</p></li>
            </ul>
          </section>
        </motion.div>
      </div>
      <div className="breadcrumb-container">
        <Breadcrumb paths={paths} />
      </div>
    </>
  );
};

export default CompanyOverview;